import gql from 'graphql-tag';

export default gql`
  mutation ($_id: MongoID!) {
    removeCourse(_id: $_id) {
      recordId
    }
  }
`;
